import { fb, db } from '@/lib/common'

export default {
  updateArticle: async ({ state, commit }, { pageId, articleId, data }) => {
    const created = data.created ? 'modified' : 'created'
    data[created] = fb.firestore.FieldValue.serverTimestamp()
    data[`${created}_by`] = state.user.email
    await db.doc(`pages/${pageId}/articles/${articleId}`).set(data)
  },
  deleteArticle: async ({ commit }, { pageId, articleId }) => {
    await db.doc(`pages/${pageId}/articles/${articleId}`).delete()
    commit('deleteArticle', { pageId, articleId })
  },
  fetchPages: async ({ commit }) => {
    const snapshot = await db.collection('pages').get()
    if (snapshot.docs.length) {
      snapshot.docs.forEach(
        doc => commit('setPage', { ...doc.data(), id: doc.id })
      )
    } else {
      throw new Error('Not Found')
    }
  },
  fetchLists: async ({ commit }, pageId) => {
    const snapshot = await db.collection(`pages/${pageId}/lists`)
      .where('publication_date', '<=', new Date())
      .orderBy('publication_date', 'desc')
      .limit(1).get()
    if (snapshot.docs.length) {
      const data = snapshot.docs[0].data()
      commit('setList', { pageId, data })
    } else {
      throw new Error('Not Found')
    }
  },
  /* fetchLatestList: async ({ commit }, pageId) => {
    const snapshot = await db.collection(`pages/${pageId}/lists`)
      .where('publication_date', '<=', new Date())
      .orderBy('publication_date', 'desc')
      .limit(1).get()
    if (snapshot.docs.length) {
      const data = snapshot.docs[0].data()
      commit('setList', { pageId, data })
    } else {
      throw new Error('Not Found')
    }
  }, */
  fetchArticle: async ({ commit }, { pageId, articleId }) => {
    const doc = await db.doc(`pages/${pageId}/articles/${articleId}`).get()
    if (doc.exists) {
      commit('setArticle', {
        pageId,
        data: { ...doc.data(), id: doc.id }
      })
    } else {
      throw new Error('Not Found')
    }
  },
  fetchArticles: async ({ commit }, pageId) => {
    const snapshot = await db.collection(`pages/${pageId}/articles`).get()
    if (snapshot.docs.length) {
      snapshot.docs.forEach(
        doc => commit('setArticle', {
          pageId,
          data: { ...doc.data(), id: doc.id }
        })
      )
    } else {
      throw new Error('Not Found')
    }
  },
  uploadStorage: async ({ state, commit }, { fullPath, source, metadata }) => {
    const storageRef = fb.storage().ref()
    const ref = storageRef.child(fullPath)
    await ref.put(source, metadata)
    /* const uploadTask = fileRef.putString(
      source,
      'data_url',
      metadata
    )
    uploadTask.on(
      'state_changed',
      snapshot => {
        // state.imageUploadProgress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        switch (snapshot.state) {
          case fb.storage.TaskState.PAUSED: // or 'paused'
            console.log('Upload is paused')
            break
          case fb.storage.TaskState.RUNNING: // or 'running'
            console.log('Upload is running')
            break
        }
      },
      error => {
        console.error(error)
      },
      () => {
        console.log('complete')
      }
    ) */
    return false
  },
  addImage: async ({ state, commit }, { pageId, filename, fullPath }) => {
    const data = {
      full_path: fullPath,
      created: fb.firestore.FieldValue.serverTimestamp(),
      created_by: state.user.email
    }
    await db.doc(`pages/${pageId}/images/${filename}`).set(data)
  },
  fetchImages: async ({ commit }, pageId) => {
    const snapshot = await db.collection(`pages/${pageId}/images`).get()
    if (snapshot.docs.length) {
      commit('clearImages', pageId)
      snapshot.docs.forEach(
        doc => commit('setImage', {
          pageId,
          data: { ...doc.data(), id: doc.id }
        })
      )
    } else {
      throw new Error('Not Found')
    }
  },
  deleteImage: async ({ commit }, { pageId, id }) => {
    await db.doc(`pages/${pageId}/images/${id}`).delete()
    commit('deleteImage', { pageId, id })
  }
}
